export default __webpack_public_path__ + "static/media/talent-profile.28bf5b47.jpeg";